import { render, staticRenderFns } from "./applydetail.vue?vue&type=template&id=0fe81d6d&scoped=true&"
import script from "./applydetail.vue?vue&type=script&lang=js&"
export * from "./applydetail.vue?vue&type=script&lang=js&"
import style0 from "./applydetail.vue?vue&type=style&index=0&id=0fe81d6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe81d6d",
  null
  
)

export default component.exports